import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  constructor(private http: HttpClient) {}

  i18n: { [key: string]: { zh: string; en: string } } = {};
  getI18nJson() {
    return this.http.get('assets/i18n/translate.json').pipe(
      tap((res: any) => {
        this.i18n = res || {};
      })
    );
  }

  instant(key: string): string {
    if (!this.i18n[key]) return key;
    return localStorage.NG_TRANSLATE_LANG_KEY === 'en' ? this.i18n[key].en : this.i18n[key].zh;
  }
}
